// passengersApi.ts
import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse, PassengerDetail } from "../../Orchestrator/Types/Index";
import { IPatchPassengerRequest } from "../../Orchestrator/Types/Interface/IPurchaserRequest";

export async function patchPassenger(
  passengerRequest: IPatchPassengerRequest,
  bookingId: string,
  showLoader?: boolean
): Promise<IApiResponse<PassengerDetail>> {
  const ENDPOINTS = await getEndpoints();
  const endpoint = `${ENDPOINTS.patchPassenger}/${bookingId}/passengers/${passengerRequest.id}`;
  const body = JSON.stringify(passengerRequest);

  return await apiRequest<PassengerDetail>(endpoint, "PATCH", {
    body: body,
  }, 'none', undefined, undefined, showLoader);
}
